"use client";

import AccordionItemBlok from "@/components/bloks/sections/Accordion/AccordionItem";
import {
  AccordionContent,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "@/components/ui/Accordion";
import { useGlobalData } from "@/features/GlobalDataContext/GlobalDataContext";
import type { ProductPageStoryblok } from "@/generated/sb/sb-types";
import { useTranslations } from "@/i18n/client";
import type { ProductDetails } from "@/lib/centra/formatters";

export interface ProductAccordionsProps {
  storyblokAccordion?: ProductPageStoryblok["accordion"];
  product: ProductDetails;
}

export const ProductAccordions = ({
  product,
  storyblokAccordion,
}: ProductAccordionsProps) => {
  const t = useTranslations();
  const { preview } = useGlobalData();

  return (
    <AccordionRoot>
      {product?.keyFeatures && (
        <AccordionItem>
          <AccordionTrigger>{t("Key features")}</AccordionTrigger>
          <AccordionContent>
            <div
              dangerouslySetInnerHTML={{
                __html: product?.keyFeatures.replace(/\n/g, "<br>"),
              }}
            />
          </AccordionContent>
        </AccordionItem>
      )}
      {product?.fit && (
        <AccordionItem>
          <AccordionTrigger>{t("Fit")}</AccordionTrigger>
          <AccordionContent>
            <div
              dangerouslySetInnerHTML={{
                __html: product?.fit.replace(/\n/g, "<br>"),
              }}
            />
          </AccordionContent>
        </AccordionItem>
      )}
      {(product?.fabric?.text ||
        product?.fabric?.details ||
        product?.filling ||
        product?.lining) && (
        <AccordionItem>
          <AccordionTrigger>{t("Fabric and details")}</AccordionTrigger>
          <AccordionContent>
            {product?.fabric?.text && (
              <>
                <p>{t("Fabric")}:</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: product?.fabric?.text.replace(/\n/g, "<br>"),
                  }}
                />
              </>
            )}
            {product?.fabric.details && (
              <>
                <p>{t("Details")}:</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: product?.fabric.details.replace(/\n/g, "<br>"),
                  }}
                />
              </>
            )}
            {product?.filling && (
              <>
                <p>{t("Filling")}:</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: product?.filling.replace(/\n/g, "<br>"),
                  }}
                />
              </>
            )}
            {product?.lining && (
              <>
                <p>{t("Lining")}:</p>
                <p
                  dangerouslySetInnerHTML={{
                    __html: product?.lining.replace(/\n/g, "<br>"),
                  }}
                />
              </>
            )}
          </AccordionContent>
        </AccordionItem>
      )}
      {product?.care && (
        <AccordionItem>
          <AccordionTrigger>{product?.care.label}</AccordionTrigger>
          <AccordionContent>
            <div
              dangerouslySetInnerHTML={{
                __html: product?.care.description.replace(/\n/g, "<br>"),
              }}
            />
          </AccordionContent>
        </AccordionItem>
      )}
      {storyblokAccordion?.map(item => (
        <AccordionItemBlok item={item} key={item._uid} preview={preview} />
      ))}
    </AccordionRoot>
  );
};
